<p-dialog
  header="Create company"
  modal
  [(visible)]="isOpen"
  [style]="{ width: '26rem' }"
  (onHide)="closeModal()"
>
  <form
    class="company-form"
    [formGroup]="formGroup"
    #companyForm="ngForm"
    (ngSubmit)="onSubmitLicense(companyForm)"
  >
    <div class="form-group">
      <p-floatlabel>
        <input
          pInputText
          type="text"
          name="name"
          inputId="name"
          formControlName="name"
          fluid
        />
        <label for="name">Company name</label>
      </p-floatlabel>
    </div>
    <div class="form-group">
      <p-fileupload
        #fileUploader
        class="logo-upload"
        #fileUpload
        mode="basic"
        [chooseLabel]="logoSrc ? 'Change logo' : 'Upload logo'"
        chooseIcon="pi pi-upload"
        accept="image/*"
        maxFileSize="1000000"
        customUpload="true"
        (onSelect)="onSelectFile($event)"
      />

      @if (logoSrc) {
      <div class="logo-preview__container">
        <img [src]="logoSrc" alt="Vista previa" width="200" />
        <div class="logo-preview__data">
          <div class="logo-preview__file-name">
            {{ this.logoFile?.name }}
          </div>
          <div class="logo-preview__file-size">
            @if (this.logoFile) { {{ this.logoFile.size | fileSize }} }
          </div>
        </div>
        <p-button
          class="logo-preview__delete-btn"
          icon="pi pi-times"
          [rounded]="true"
          severity="danger"
          variant="outlined"
          title="Delete logo"
          size="small"
          (click)="onDeleteLogoClick()"
        ></p-button>
      </div>
      }
    </div>

    <div class="form-actions">
      <p-button
        label="Cancel"
        variant="text"
        severity="secondary"
        (click)="closeModal()"
      ></p-button>
      <p-button
        type="submit"
        label="Save"
        [disabled]="!companyForm.valid"
        raised
      ></p-button>
    </div>
  </form>
</p-dialog>
